import { CarouselNext, CarouselPrevious } from "components/ui/carousel";

const ImageSliderButtons = () => {
  return (
    <div className="flex">
      <CarouselPrevious
        className="!relative !left-auto !flex h-10 w-10 !translate-y-0 cursor-pointer items-center justify-center rounded-full border border-gray-200 transition-colors hover:!bg-transparent disabled:!bg-transparent"
        iconClassName="!h-6 !w-6"
      />
      <CarouselNext
        className="!relative !right-auto ml-[10px] !flex h-10 w-10 !translate-y-0 cursor-pointer items-center justify-center rounded-full border border-gray-200 transition-colors hover:!bg-transparent disabled:!bg-transparent"
        iconClassName="!h-6 !w-6"
      />
    </div>
  );
};

export default ImageSliderButtons;
